<template>
  <div v-if="isLoading" id="loading" :class="mode">
    <div class="logo"></div>
    <div class="loading">
      <div class="loadingImage"></div>
      <div class="loadingText">
        <h3>{{ t('loading') }}</h3>
        <span>{{ t('loading-title') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, watch} from "#imports";
import {useLoadingStore} from "~/store/loading/loadingStore";
import { useI18n } from "vue-i18n";

const loadingStore = useLoadingStore();
const isLoading = ref(loadingStore.show);
const mode = ref(loadingStore.mode);

const { t } = useI18n();

loadingStore.$subscribe((mutation, state) => {
  isLoading.value = state.show;
  mode.value = state.mode;
});

watch(() => loadingStore.show, () => {
  isLoading.value = loadingStore.show;
  mode.value = loadingStore.mode;
}, {
  immediate: true
})
</script>